import { enGB } from 'date-fns/locale';
import { localDayBounds, formatLondon } from './dateFormatting';

// Shared Chart.js building blocks for the portal's time-series charts.
// Rules from CLAUDE.md "Frontend gotchas":
//  - the x-axis is pinned to the selected London day, never auto-scaled to data;
//  - with a time scale and {x,y} data, never set chartData.labels;
//  - a chart-level spanGaps breaks 30-min forecast lines, so forecast datasets
//    set spanGaps: true themselves.

export function dayRange(selectedDate) {
    if (!selectedDate) return { dayStart: undefined, dayEnd: undefined };
    const { start, end } = localDayBounds(selectedDate);
    return { dayStart: start, dayEnd: end };
}

export function timeAxis(selectedDate) {
    const { dayStart, dayEnd } = dayRange(selectedDate);
    return {
        type: 'time',
        min: dayStart,
        max: dayEnd,
        adapters: { date: { locale: enGB } },
        time: {
            parser: "yyyy-MM-dd'T'HH:mm:ssX",
            tooltipFormat: 'dd MMM yyyy HH:mm',
            unit: 'hour',
            displayFormats: { hour: 'HH:mm', day: 'dd MMM' },
        },
        ticks: {
            maxTicksLimit: 14,
            font: { size: 10 },
            callback: (value) => formatLondon(value, 'dateTime'),
        },
        grid: { display: false },
    };
}

export function valueAxis(unitLabel, extra = {}) {
    return {
        type: 'linear',
        display: true,
        position: 'left',
        title: { display: true, text: unitLabel, font: { size: 11 } },
        grid: { color: 'rgba(0,0,0,0.04)' },
        ...extra,
        ticks: { font: { size: 10 }, ...(extra.ticks || {}) },
    };
}

// Options common to every portal chart. `label` formats one tooltip line.
export function baseOptions({ legendPosition = 'top', legendPadding = 12, label, scales }) {
    return {
        layout: { padding: { left: 10, right: 10, top: 10, bottom: 10 } },
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: legendPosition,
                labels: { usePointStyle: true, pointStyle: 'rect', padding: legendPadding, font: { size: 11 } },
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                backgroundColor: 'rgba(255,255,255,0.95)',
                titleColor: '#333',
                bodyColor: '#666',
                borderColor: '#ddd',
                borderWidth: 1,
                padding: 10,
                callbacks: { label },
            },
        },
        interaction: { mode: 'nearest', axis: 'x', intersect: false },
        scales,
    };
}
